<ion-card>
  <ion-card-header class="ion-text-center">
    <ion-card-title>App Info</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div class="ion-text-center">
      Version: {{version}}
    </div>
  </ion-card-content>
</ion-card>